import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';

export interface PlantTreeState {
    rankList: ListWrap<PlantTree.RankItem> & ListRequesting;
    info: PlantTree.Info | null;
    treeList: PlantTree.TreeItem[];
}

const m: Module<PlantTreeState, RootState> = {
    namespaced: true,
    state: () => ({
        rankList: {
            list: [],
            loaded: false,
            requesting: false,
        },
        info: null,
        treeList: [],
    }),
    mutations: {
        concatList(state, list) {
            state.rankList.list.push(...list);
        },
        setListLoaded(state, loaded) {
            state.rankList.loaded = loaded;
        },
        setListReq(state, req) {
            state.rankList.requesting = req;
        },
        setInfo(state, info: PlantTree.Info) {
            state.info = info;
        },
        setTreeList(state, list) {
            state.treeList = list;
        },
    },
    actions: {
        /**
         * 获取排行榜
         * @param {} offset
         * @param {} count
         * @param {} forceUpdate
         */
        async getRankList({ state, commit }, { offset,
        count, forceUpdate = false }) {
            const wrap = state.rankList;
            if (wrap.requesting || (wrap.loaded && !forceUpdate)) {
                return;
            }
            if (forceUpdate) {
                wrap.loaded = false;
                wrap.list = [];
            }
            const list = wrap.list;
            const end = offset + count;
            if (end <= list.length) {
                return;
            }
            if (offset < list.length) {
                offset = list.length;
                count = end - offset;
            }
            commit('setListReq', true);
            const response = await Vue.axios.get('/api/v1/temp_activity/period_14_tree/rank', {
                params: {
                    offset,
                    count,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('concatList', rdata.data);
                if (rdata.data.length < count) {
                    commit('setListLoaded', true);
                }
            }
            commit('setListReq', false);
            return rdata;
        },
        /**
         * 获取活动信息
         * @param {} forceUpdate
         */
        async getActivityInfo({ state, commit }, forceUpdate = false) {
            if (state.info && !forceUpdate) {
                return;
            }
            const response = await Vue.axios.get('/api/v1/temp_activity/period_14_tree/info');
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setInfo', rdata.data);
            }
            return rdata;
        },
        /**
         * 获取树苗列表
         * @param {} forceUpdate
         */
        async getTreeList({ state, commit }, forceUpdate = false) {
            if (state.treeList && !forceUpdate) {
                return;
            }
            const response = await Vue.axios.get('/api/v1/temp_activity/period_14_tree/my_trees');
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setTreeList', rdata.data);
            }
            return rdata;
        },
        /**
         * 提交命名
         */
        async pushName({ state }, { id, name }) {
            const response = await Vue.axios.post('/api/v1/temp_activity/period_14_tree/name_tree', {
                id,
                name,
            });
            const rdata = response.data;
            return rdata;
        },
    },
};

export default m;
